// AUTO-GENERATED at 2026-05-08T10:39:40.848Z — do not edit
export const BUILD_INFO = {
  "commitDate": "2026-05-08T12:26:33+02:00",
  "commitHash": "979955a9",
  "commitMsg": "Aggiunge Preset Cliente: salva/carica intero setup visuale per cliente",
  "buildDate": "2026-05-08T10:39:40.848Z",
  "environment": "production"
};
